import { Injectable } from '@angular/core';

/**
 * Accessibility Clarity Service
 *
 * @description Manage Accessibility Clarity PDF Information
 */
@Injectable({
    providedIn: 'root',
})
export class AccessibilityPdfService {

    /**
     * @desc Get Accessibility check icon container for a document
     * @param {object} document
     * @param {object} check
     * @return {string}
     */
    getDocumentIconContainer (document: any, check: any): string | undefined {
        if (!this.isObject(document) || !this.isObject(check)) {
            return;
        }
        if (
            document.clarity_queued_at !== null ||
            (document.clarity_queued_at === null && document.clarity_checked_at === null) ||
            document.clarity_tagged === false
        ) {
            return 'fal fa-circle text-grey';
        } else if (check.errors_count > 0) {
            return 'fal fa-circle text-wcag-a';
        } else if (check.errors_count === 0) {
            return 'fas fa-circle text-green';
        }
        return undefined;
    }

    /**
     * @desc Get Accessibility check icon for a document
     * @param {object} document
     * @param {object} check
     * @return {string}
     */
    getDocumentIcon (document: any, check: any): string | undefined {
        if (!this.isObject(document) || !this.isObject(check)) {
            return;
        }
        if (
            document.clarity_queued_at !== null ||
            (document.clarity_queued_at === null && document.clarity_checked_at === null) ||
            document.clarity_tagged === false
        ) {
            return 'fas fa-file-alt text-grey';
        } else if (check.errors_count > 0) {
            return 'fas fa-file-alt text-wcag-a';
        } else if (check.errors_count === 0) {
            return 'fas fa-check fa-inverse';
        }
        return undefined;
    }

    /**
     * @desc Check if value is a of type function
     * @param {any} val
     * @return {boolean}
     */
    private isObject (val: any): boolean {
        return val !== null && !Array.isArray(val) && typeof val === 'object';
    }
}
